export default "__VITE_ASSET__135ccd9c__"